// Imported emails are stored once per company and associated with known people.
function activityBelongsTo(activity, type, id, data) {
    if (activity.recordType === type && activity.recordId === id) return true;
    if (type === 'contacts' && activity.relatedContactIds?.includes(id)) return true;
    if (type === 'companies') return ['contacts', 'deals'].includes(activity.recordType) && data[activity.recordType].some(record => record.id === activity.recordId && record.companyId === id);
    return type === 'contacts' && activity.recordType === 'deals' && data.deals.some(record => record.id === activity.recordId && record.contactId === id);
}
module.exports = { activityBelongsTo };
